export const actionTypes = {
  GET_INFO: 'APP.AVATAR.GET_INFO',
  REQUEST_SUCCESS: 'APP.AVATAR.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'APP.AVATAR.REQUEST_FAILURE',
};

export function getAvatar() {
  return {
    type: actionTypes.GET_INFO,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}
